import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import moment from 'moment'
moment.locale('zh-cn')
import axios from 'axios'

// import echarts from "echarts"
// Vue.prototype.$echarts = echarts 1

const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus, { locale })
app.config.globalProperties.$moment = moment
app.config.globalProperties.$axios = axios
const vm = app.mount('#app')
